var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockRoundedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.125,
    cy: 24.75,
    r: 24,
    fill: "#00A3E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.78 30.13C27.96 30.31 28.17 30.4 28.41 30.4C28.65 30.4 28.87 30.3 29.07 30.1C29.27 29.9 29.375 29.67 29.385 29.41C29.395 29.15 29.3 28.93 29.1 28.75L24.99 24.64V19.48C24.99 19.24 24.905 19.035 24.735 18.865C24.565 18.695 24.35 18.61 24.09 18.61C23.83 18.61 23.615 18.695 23.445 18.865C23.275 19.035 23.19 19.25 23.19 19.51V25C23.19 25.12 23.21 25.23 23.25 25.33C23.29 25.43 23.35 25.53 23.43 25.63L27.78 30.13ZM24 37C22.36 37 20.81 36.685 19.35 36.055C17.89 35.425 16.615 34.565 15.525 33.475C14.435 32.385 13.575 31.11 12.945 29.65C12.315 28.19 12 26.64 12 25C12 23.36 12.315 21.81 12.945 20.35C13.575 18.89 14.435 17.615 15.525 16.525C16.615 15.435 17.89 14.575 19.35 13.945C20.81 13.315 22.36 13 24 13C25.64 13 27.19 13.315 28.65 13.945C30.11 14.575 31.385 15.435 32.475 16.525C33.565 17.615 34.425 18.89 35.055 20.35C35.685 21.81 36 23.36 36 25C36 26.64 35.685 28.19 35.055 29.65C34.425 31.11 33.565 32.385 32.475 33.475C31.385 34.565 30.11 35.425 28.65 36.055C27.19 36.685 25.64 37 24 37ZM24 35.2C26.8 35.2 29.2 34.2 31.2 32.2C33.2 30.2 34.2 27.8 34.2 25C34.2 22.2 33.2 19.8 31.2 17.8C29.2 15.8 26.8 14.8 24 14.8C21.2 14.8 18.8 15.8 16.8 17.8C14.8 19.8 13.8 22.2 13.8 25C13.8 27.8 14.8 30.2 16.8 32.2C18.8 34.2 21.2 35.2 24 35.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockRoundedBlue);
export default __webpack_public_path__ + "static/media/clock-rounded-blue.507b8af99f6f3a2a8c14a7cb25e5e79e.svg";
export { ForwardRef as ReactComponent };